module["exports"] = [
  "np",
  "com",
  "info",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/internet/domain_suffix.js
// module id = 2530
// module chunks = 2